import { render, staticRenderFns } from "./quizBox.vue?vue&type=template&id=46fe9b93&scoped=true&"
import script from "./quizBox.vue?vue&type=script&lang=js&"
export * from "./quizBox.vue?vue&type=script&lang=js&"
import style0 from "./quizBox.vue?vue&type=style&index=0&id=46fe9b93&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fe9b93",
  null
  
)

export default component.exports